<nav class="navbar navbar-toggleable-md navbar-inverse bg-light">
    <a class="navbar-brand" [routerLink]="'/'" title="APP_NAME" translate>
        <img src="./assets/images/logo.png" style="width:300px;">
    </a>
</nav>
